import { openMessengerForm } from './openMessengerForm';

const timeout = (ms) =>
    new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Timeout')), ms);
    });

export const smartMessengersHandler = () => {
    const messengers = document.querySelectorAll('[data-messenger]');

    messengers.forEach((messenger) => {
        messenger.addEventListener('click', async (e) => {
            e.preventDefault();

            const targetHref = messenger.href;
            const source = messenger.dataset.messenger;

            try {
                const data = await Promise.race([
                    fetch(`https://rechistart.ru/country.php?nocache=${Date.now()}`)
                        .then((res) => {
                            if (!res.ok) {
                                throw new Error(`Ошибка API: ${res.status}`);
                            }

                            return res.json();
                        }),
                    timeout(7000)
                ]);

                if (typeof data?.country === 'string' && data.country !== 'RU') {
                    window.location.assign(targetHref);
                } else {
                    openMessengerForm(source);
                }
            } catch (error) {
                console.error(
                    'Ошибка определения страны, открываем форму:',
                    error
                );

                openMessengerForm(source);
            }
        });
    });
};